<ng-container *ngIf="entity">
  <ng-container
    *ngIf="
      isSyncLatestJoinState || entity.hasJoined === undefined || isPaying;
      else joinEventTemp
    "
  >
    <i class="fas fa-spinner fa-spin"></i>
  </ng-container>
  <ng-template #joinEventTemp>
    <div *ngIf="!entity.hasJoined; else joinedTemp" class="event-register-btn">
      <button
        type="button"
        appDebounceClick
        appTooltip
        class="btn btn-interact btn-primary mw-100"
        (debounceClick)="join($event, entity)"
        [class.btn-interact--big]="btnStyle === 'standard'"
        [class.btn-interact--small]="btnStyle === 'minimal'"
        [ngbTooltip]="entity | eventRegisterTooltip | translate"
        [disabled]="entity | eventRegisterBtnDisabled"
        [class.disable-register]="entity | eventRegisterBtnDisabled"
      >
        <ng-container *ngIf="btnStyle === 'standard'; else minimalBtn">
          <i class="register-icon fas fa-file-medical"></i>
          <span class="text-hide-small">
            {{ 'UI.Event.Register' | translate }}
          </span>
        </ng-container>

        <ng-template #minimalBtn>
          <span class="truncate-line-1" translate
            >UI.Event.RegisterThisEvent</span
          >
        </ng-template>
      </button>
    </div>
    <ng-template #joinedTemp>
      <button
        *ngIf="!isOwner; else isOwnerRegisterBtn"
        appLeaveEntity
        [entityId]="entity.id"
        [entityName]="entityName"
        (afterLeaved)="leave($event)"
        class="btn btn-interact btn-interact--big btn-is-member"
      >
        <i class="fas fa-check-circle"></i>

        <span class="text-hide-small">
          {{ 'UI.Event.Registered' | translate }}</span
        >
      </button>

      <ng-template #isOwnerRegisterBtn>
        <button
          class="btn btn-interact btn-interact--big btn-is-member default-cursor"
        >
          <i class="fas fa-check-circle"></i>

          <span class="text-hide-small">
            {{ 'UI.Event.Registered' | translate }}</span
          >
        </button>
      </ng-template>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #joinedNotificationModal>
  <div class="px-4 pt-3">
    <h4 class="m-0 font-weight-bold something-wrong-modal-title" translate>
      {{ 'Registration Successful!' | translate }}
    </h4>
  </div>
  <div class="modal-body">
    <p class="m-0 mt-3">
      A confirmation E-Mail has been sent to
      <span class="font-weight-bold">{{ (userProfile$ | async)?.email }}</span>
    </p>
    <p class="mt-3 mb-0">
      There is a QR code in the confirmation E-Mail, please show that code to
      event for check in.
    </p>
  </div>
  <div class="modal-footer pt-0">
    <button
      type="button"
      class="btn btn-primary mx-auto w-100"
      translate
      (click)="afterJoinedModalRef.close()"
    >
      OK
    </button>
  </div>
</ng-template>
